<template>
    <header id="header" class="container-fluid flex-center bg-lightiest-gray">
        <section class="row w-100">
            <div class="col-12 flex-between-center">
                <div class="flex-center">
                    <div class="flex-center me-2">
                        <div class="bg-primary flex-center rounded-circle " style="width: 40px; height: 40px;">
                            <span class="ge--description-sm text-white" style="letter-spacing: 2px;" v-if="session">
                                <strong>
                                    {{ session.Nombre[0] }}{{ session.Apellido[0] }}
                                </strong>
                            </span>
                        </div>
                    </div>

                    <div class="text-start" style="line-height: 1.2">
                        <div class="mt-1">
                            <span class="d-block" style="font-size: 20px; font-weight: bolder;">
                                {{ session.Nombre }} {{ session.Apellido }}
                            </span>
                            <span class="d-block">
                                <i>
                                    {{ session.Username }}    
                                </i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="flex-center d-none d-sm-flex">
                    <div class="d-flex position-relative mx-2">
                        <img width="28" height="28" :src="bell" alt="">
                        <span class="red_dot text-center">
                            1
                        </span>
                    </div>
                    <img :src="user" width="28" height="28" class="mx-2">
                </div>
            </div>
        </section>
    </header>
</template>

<script setup>
    //icons
    const avatar = require('ASSETS/images/avatar')
    const bell = require('ASSETS/icons/bell')
    const user = require('ASSETS/icons/user')

    //vue
    import { computed } from 'vue';
    import { useStore} from 'vuex'

    //hooks
    const store = useStore()

    //computed
    const session = computed(() => (store.getters['getSession']))
</script>

<style lang="scss" scoped>
    #header {
        position: absolute;
        padding-left: 150px;
        height: 74px;
        z-index: -1;
        

        .red_dot{
            background: red;
            height: 20px;
            color: white;
            width: 20px;
            padding-top: 1px;
            padding-left: 2px;
            font-size: 12px;
            border-radius: 50%;
            position: absolute;
            bottom: 50%;
            right: -20%;
        }
    }
</style>